import { useCallback } from "react";
import { listFeeds } from "../../services/requestFeeds";
import { logToClientLogger } from "../../helpers/clientLogger";
import { getCategories, getCategoryParam } from "../../helpers/helpers";

export function useQueryFeeds({state, dispatch}) {
  const { feeds } = state;

  const request = useCallback(async (childId) => {
    const feedIds = `child:${childId}`;
    dispatch({type: "setFeedsStatus", payload: "loading"});

    try {
      const data = await listFeeds(feedIds);
      const feedCategories = getCategories(data);
      const categoryParam = getCategoryParam();
      dispatch({type: "setFeedsData", payload: data});
      dispatch({type: "setFeedsStatus", payload: data});
      dispatch({type: "setFeedCategories", payload: feedCategories});
      dispatch({type: "setCategory", payload: categoryParam.filter_string});
      return data;
    } catch (err) {
      // TODO Log Error
      dispatch({type: "setFeedsStatus", payload: "error"});
      console.log(err);
      logToClientLogger(err);
    }
  }, [dispatch]);

  return {
    ...feeds,
    request,
    isPending: feeds.status === "pending",
    isLoading: feeds.status === "loading",
    isWaiting: ["loading", "pending"].includes(feeds.status),
    isError: feeds.status === "error",
    isSuccess: feeds.status === "success",
    isComplete: ["success", "error"].includes(feeds.status)
  }
}

export default useQueryFeeds;